import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import type { Component } from 'vue';
import IconPayments from '@/components/icons/IconPayments.vue';
import PageView from '@/components/ui/PageView.vue';
import SectionTabView from '@/components/ui/SectionTabView.vue';
import AllPaymentsTab from '@/views/payments/AllPaymentsTab.vue';
import DepositsTab from '@/views/payments/DepositsTab.vue';
import OtherPaymentsTab from '@/views/payments/UpcomingPaymentsTab.vue';
// DPG-4532: Low Balance and the cancelled-only Other tab are commented out in
// LowBalancePaymentsTab.vue / OtherTransactionsTab.vue — the Other tab's status filter replaced them.
// import LowBalancePaymentsTab from '@/views/payments/LowBalancePaymentsTab.vue';
// import OtherTransactionsTab from '@/views/payments/OtherTransactionsTab.vue';
import type { PaymentsTabId } from '@/composables/usePayments';
import type { SectionTab } from '@/components/ui/SectionTabView.vue';

const DEFAULT_TAB_ID: PaymentsTabId = 'all';


export default /*@__PURE__*/_defineComponent({
  __name: 'PaymentsView',
  setup(__props) {

/* eslint-env vue/setup-compiler-macros */
const TABS: SectionTab[] = [
    { id: 'all', label: 'All' },
    { id: 'deposits', label: 'Deposits' },
    { id: 'other', label: 'Other' },
    // { id: 'low-balance', label: 'Low Balance Payments' },
    // { id: 'other-transactions', label: 'Other Transactions' },
];

const tabComponents: Record<PaymentsTabId, Component> = {
    all: AllPaymentsTab,
    deposits: DepositsTab,
    other: OtherPaymentsTab,
    // 'low-balance': LowBalancePaymentsTab,
    // 'other-transactions': OtherTransactionsTab,
};

const route = useRoute();
const router = useRouter();

const isPaymentsTabId = (value: unknown): value is PaymentsTabId => (
    typeof value === 'string'
    && TABS.some((tab) => tab.id === value)
);

const activeTabId = computed<PaymentsTabId>(() => {
    const tab = Array.isArray(route.query.tab)
        ? route.query.tab[0]
        : route.query.tab;

    return isPaymentsTabId(tab) ? tab : DEFAULT_TAB_ID;
});

const selectTab = (tabId: string) => {
    if (!isPaymentsTabId(tabId) || tabId === activeTabId.value) {
        return;
    }

    const nextQuery = { ...route.query };
    // A deep-linked status belongs to the tab it pointed at; the next tab starts from its own base.
    delete nextQuery.status;

    if (tabId === DEFAULT_TAB_ID) {
        delete nextQuery.tab;
    } else {
        nextQuery.tab = tabId;
    }

    router.push({
        name: 'payments',
        query: nextQuery,
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageView, {
    title: "Payments",
    icon: IconPayments
  }, {
    default: _withCtx(() => [
      _createVNode(SectionTabView, {
        tabs: TABS,
        "active-tab-id": activeTabId.value,
        onTabChange: selectTab
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(tabComponents[activeTabId.value]), { "tab-id": activeTabId.value }, null, 8, ["tab-id"]))
        ]),
        _: 1
      }, 8, ["active-tab-id"])
    ]),
    _: 1
  }))
}
}

})